import { useAuth } from "provider/AuthContext";
import { useDrawerContext } from "provider/DrawerProvider";
import React, { useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Offcanvas } from "bootstrap";
import dpimg from "assets/img/dpmain.png";

const Drawer = () => {
    const { drawerDispatch, drawerState, drawerRef } = useDrawerContext();
    const instanceRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { logout, userProfile } = useAuth();
    const referrer = location.pathname + location.search;

    const handleLogout = () => {
        logout();
        navigate(referrer, { replace: true });
        window.location.reload();
    };

    // Initialize offcanvas
    useEffect(() => {
        if (drawerRef.current && !instanceRef.current) {
            instanceRef.current = new Offcanvas(drawerRef.current);
        }
    }, [drawerRef]);

    // Show/hide offcanvas based on state
    useEffect(() => {
        if (instanceRef.current) {
            if (drawerState.showDrawer) {
                instanceRef.current.show();
            } else {
                instanceRef.current.hide();
            }
        }
    }, [drawerState.showDrawer]);

    // Close handler
    useEffect(() => {
        const element = drawerRef.current;
        if (element) {
            const handleHidden = () => drawerDispatch({ type: "CLOSE_DRAWER" });
            element.addEventListener("hidden.bs.offcanvas", handleHidden);
            return () => {
                element.removeEventListener("hidden.bs.offcanvas", handleHidden);
            };
        }
    }, []);


    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            ref={drawerRef}
            id="globalDrawer"
            style={{width:"90%"}}
        >
            {/* <div className="offcanvas-header border-bottom">
        <h5 className="mb-0">Menu</h5>
        <button
          type="button"
          className="btn-close text-reset"
          aria-label="Close"
          onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}
        />
      </div> */}

            <div className="offcanvas-body mt-2 p-3 d-flex flex-column justify-content-between">
                <div>
                    {/* Profile section */}
                    <div className="d-flex align-items-center mb-4">
                        <img
                            src={userProfile?.profile_display_image || dpimg}
                            alt="User"
                            className="rounded-circle me-3"
                            width="45"
                            height="45"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = dpimg;
                            }}
                        />
                        <div>
                            <h6 className="mb-0">{userProfile?.name || "User"}</h6>
                            <small className="text-muted">@{userProfile?.user_handle || "username"}</small>
                        </div>
                    </div>

                    {/* Menu List */}
                    <ul className="list-unstyled">
                        <li className="mb-3">
                            <Link
                                to={`/profile/user/${userProfile?.user_handle}`}
                                className="text-decoration-none text-dark d-flex align-items-center"
                                onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}
                            >
                                <i className="fa-solid fa-user me-2"></i> Profile
                            </Link>
                        </li>
                        {!userProfile?.is_safari_operator &&
                            <>
                                <li className="mb-3">
                                    <Link
                                        to="/account"
                                        className="text-decoration-none text-dark d-flex align-items-center"
                                        onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}
                                    >
                                        <i className="fa-solid fa-cog me-2"></i> Account Settings
                                    </Link>
                                </li>
                                <li className="mb-3">
                                    <Link
                                        to="/account/wishlist"
                                        className="text-decoration-none text-dark d-flex align-items-center"
                                        onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}
                                    >
                                        <i className="fa-solid fa-heart me-2"></i> Wishlist
                                    </Link>
                                </li>
                            </>
                        }
                        <li className="border-top pt-3">
                            <button
                                className="btn btn-link text-danger text-decoration-none d-flex align-items-center p-0"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout();
                                    drawerDispatch({ type: "CLOSE_DRAWER" });
                                }}
                            >
                                <i className="fa-solid fa-arrow-right-from-bracket me-2"></i> Log Out
                            </button>
                        </li>
                    </ul>
                </div>

                <div>
                    <div className="small">
                        <div className="border-top pt-1 ">
                            <ul className=" d-flex flex-row justify-content-between list-unstyled mb-1">
                                <li>
                                    <Link className="text-decoration-none text-dark" to="/faq" onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}>FAQs</Link>
                                </li>
                                <li>
                                    <Link className="text-decoration-none text-dark" to="/about-us" onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}>About Us</Link>
                                </li>
                                <li>
                                    <Link className="text-decoration-none text-dark" to="/contact-us" onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}>Contact Us</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="border-top border-bottom pt-1 pb-1 ">
                            <ul className=" d-flex flex-row justify-content-between list-unstyled mb-0">
                                <li>
                                    <Link className="text-decoration-none text-dark" to="/privacy-policy" onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}>Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link className="text-decoration-none text-dark" to="/terms-of-use" onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}>Terms of Use</Link>
                                </li>
                                <li>
                                    <Link className="text-decoration-none text-dark" to="/refund-policy" onClick={() => drawerDispatch({ type: "CLOSE_DRAWER" })}>Refund Policy</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="text-start mt-4 small text-muted">
                        &copy; {new Date().getFullYear()} Walk Into The Wild | All Rights Reserved
                    </div>

                    <div className="text-start x-small color_prime mt-1  ">
                        DEVELOPED BY : MEDIARC TECHNOLOGIES PRIVATE LIMITED
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Drawer;
